export const aplicationConstants = {
    SET_APPLICATIONS_SUCCESS: 'SET_APPLICATIONS_SUCCESS',
    SET_APPLICATIONS_FAILURE: 'SET_APPLICATIONS_FAILURE',

    SET_SELECTED_APPLICATION_SUCCESS: 'SET_SELECTED_APPLICATION_SUCCESS',
    SET_SELECTED_APPLICATION_FAILURE: 'SET_SELECTED_APPLICATION_FAILURE',

    SET_APPLICATIONS_ACCOUNTS_SUCCSESS: 'SET_APPLICATIONS_ACCOUNTS_SUCCSESS',
    SET_APPLICATIONS_ACCOUNTS_FAILURE: 'SET_APPLICATIONS_ACCOUNTS_FAILURE',
  };
  